import { getBSPAllocators } from "./bspMem";
import type { LineBSP } from "./bspTypes";

export function lineBSPNew(x1: number, y1: number, z1: number, x2: number, y2: number, z2: number): LineBSP {
  const allocatorsBSP = getBSPAllocators();
  if (!allocatorsBSP) {
    return {
      x1,
      y1,
      z1,
      x2,
      y2,
      z2,
    };
  }

  const line = allocatorsBSP.allocLine();

  line.x1 = x1;
  line.y1 = y1;
  line.z1 = z1;
  line.x2 = x2;
  line.y2 = y2;
  line.z2 = z2;

  return line;
}
